// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { NodeId, NodeIdT, verifyNodeId } from "./node-id";
import {
  RelativePathElement,
  RelativePathElementT,
  verifyRelativePathElement,
} from "./relative-path-element";

/**
 * Address a node by a relative browse path from a starting node. Resolved to a
 * concrete `NodeId` at connect time via `TranslateBrowsePathsToNodeIds`.
 */
export class BrowsePath implements flatbuffers.IUnpackableObject<BrowsePathT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): BrowsePath {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsBrowsePath(bb: flatbuffers.ByteBuffer, obj?: BrowsePath): BrowsePath {
    return (obj || new BrowsePath()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsBrowsePath(bb: flatbuffers.ByteBuffer, obj?: BrowsePath): BrowsePath {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new BrowsePath()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  /**
   * Starting node (e.g. the `ObjectsFolder`, ns=0;i=85).
   */
  startingNode(obj?: NodeId): NodeId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new NodeId()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Ordered path hops.
   */
  elements(index: number, obj?: RelativePathElement): RelativePathElement | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new RelativePathElement()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  elementsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startBrowsePath(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addStartingNode(builder: flatbuffers.Builder, startingNodeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, startingNodeOffset, 0);
  }

  static addElements(builder: flatbuffers.Builder, elementsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, elementsOffset, 0);
  }

  static createElementsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startElementsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endBrowsePath(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // starting_node
    builder.requiredField(offset, 6); // elements
    return offset;
  }

  static createBrowsePath(
    builder: flatbuffers.Builder,
    startingNodeOffset: flatbuffers.Offset,
    elementsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    BrowsePath.startBrowsePath(builder);
    BrowsePath.addStartingNode(builder, startingNodeOffset);
    BrowsePath.addElements(builder, elementsOffset);
    return BrowsePath.endBrowsePath(builder);
  }

  unpack(): BrowsePathT {
    return new BrowsePathT(
      this.startingNode() !== null ? this.startingNode()!.unpack() : null,
      this.bb!.createObjList<RelativePathElement, RelativePathElementT>(
        this.elements.bind(this),
        this.elementsLength(),
      ),
    );
  }

  unpackTo(_o: BrowsePathT): void {
    _o.startingNode = this.startingNode() !== null ? this.startingNode()!.unpack() : null;
    _o.elements = this.bb!.createObjList<RelativePathElement, RelativePathElementT>(
      this.elements.bind(this),
      this.elementsLength(),
    );
  }

  unpackFields(...fields: string[]): BrowsePathT {
    const t = new BrowsePathT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("starting_node")) {
      t.startingNode = this.startingNode() !== null ? this.startingNode()!.unpack() : null;
    }
    if (fieldSet.has("elements")) {
      t.elements = this.bb!.createObjList<RelativePathElement, RelativePathElementT>(
        this.elements.bind(this),
        this.elementsLength(),
      );
    }
    return t;
  }
}

export class BrowsePathT implements flatbuffers.IGeneratedObject {
  constructor(
    public startingNode: NodeIdT | null = null,
    public elements: RelativePathElementT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.startingNode === null || this.startingNode === undefined) {
      throw new Error('Required field "starting_node" is not set');
    }
    if (this.elements === null || this.elements === undefined) {
      throw new Error('Required field "elements" is not set');
    }
    const startingNode = this.startingNode !== null ? this.startingNode!.pack(builder) : 0;
    const elements = BrowsePath.createElementsVector(
      builder,
      builder.createObjectOffsetList(this.elements),
    );

    return BrowsePath.createBrowsePath(builder, startingNode, elements);
  }

  clone(): BrowsePathT {
    const obj = new BrowsePathT();
    obj.startingNode = this.startingNode !== null ? this.startingNode!.clone() : null;
    obj.elements = this.elements.map((e) => e.clone());
    return obj;
  }

  equals(other: BrowsePathT): boolean {
    if (this.startingNode !== null && other.startingNode !== null) {
      if (!this.startingNode!.equals(other.startingNode!)) return false;
    } else if (this.startingNode !== other.startingNode) return false;
    if (this.elements.length !== other.elements.length) return false;
    for (let i = 0; i < this.elements.length; i++) {
      const a = this.elements[i];
      const b = other.elements[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyBrowsePath(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyNodeId(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "starting_node");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyRelativePathElement);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "elements");
  } finally {
    verifier.popDepth();
  }
}
